import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-open-api',
  templateUrl: './open-api.component.html',
  styleUrls: ['./open-api.component.css']
})
export class OpenAPIComponent implements OnInit {
  createOrderAPI = '/ov1/orders.json'
  getOrderAPI = '/ov1/orders/{YOUR-SYSTEM-ORDER-ID}.json';
  updateOrderAPI = '/ov1/order/{YOUR-SYSTEM-ORDER-ID}.json';
  cancelOrderAPI = '/ov1/order/{YOUR-SYSTEM-ORDER-ID}/cancel.json';

  trackingAPI = '/ov1/order/{YOUR-SYSTEM-ORDER-ID}/events.json';

  getAllStockAPI = '/ov1/stock.json';
  getSKUStockAPI = '/ov1/stock/{SKU}.json';
  getAllPricingAPI = '/ov1/pricing.json';
  getSKUPricingAPI = '/ov1/pricing/{SKU}.json';

  orderSampleCode = `{
    "id": "c43cab04-0c6f-4009-a996-8cfc7d3edcda",
    "tags": [
      "prioritised",
      "sample"
    ] ,
    "address_to": {
      "first_name": "john",
      "last_name": "smith",
      "address1": "1234 address1 line",
      "address2": "",
      "city": "EXAMPLE",
      "zip": "31345",
      "country": "US",
      "region": "NY",
      "email": "john.smith@example.com",
      "phone": "3312312231"
    },
    "address_from": {
      "company": "T-Shirt Company #1",
      "address1": "1234 address1 line",
      "address2": "",
      "city": "EXAMPLE",
      "zip": "31345",
      "country": "US",
      "region": "NY",
      "email": "company@example.com",
      "phone": "6512312231"
    },
    "shipping": {
      "carrier": "UPS",
      "priority": "Express"
    },
    "items": [
      {
        "id": "08c6e05f-f165-4729-b504-af9535946f72",
        "sku": "00846907065236",
        "preview_files": {
          "front": "https://test.com/mockup/front-url.jpeg",
          "back": "https://test.com/mockup/back-url.jpeg"
        },
        "print_files": {
          "front": "https://test.com/print/front-url.jpeg",
          "back": "https://test.com/print/back-url.jpeg",
          "left_sleeve": "https://test.com/print/left_sleeve-url.jpeg"
        },
        "quantity": 1
      },
      {
        "id": "c69a60eb-56f7-44c8-a636-11f93be08782",
        "sku": "00841016100557",
        "preview_files": {
          "front": "https://test.com/mockup/front-url.jpeg",
          "back": "https://test.com/mockup/back-url.jpeg"
        },
        "print_files": {
          "front": "https://test.com/print/front-url.jpeg"
        },
        "quantity": 1
      }
    ]
  }`;

  createOrderSuccess = `{
    "status": "success"
    "id" : "c43cab04-0c6f-4009-a996-8cfc7d3edcda",
    "reference_id" : "{Our system order number}"
  }`;

  createOrderFailed = `{
    "status": "failed",
    "errors" : [
      {
        "address_to.address1": "address1 is required!",
      },
      {
        "address_from.company": "company is required!"
      }
    ]
  }`;

  cancelOrderRequest = `{
    "items": [
      "08c6e05f-f165-4729-b504-af9535946f72",
      "c69a60eb-56f7-44c8-a636-11f93be08782"
    ]
  }`;
  cancelOrderSuccess = `{
    "status": "success",
    "items": [
      {
        "id": "08c6e05f-f165-4729-b504-af9535946f72",
        "status": "success"
      },
      {
        "id": "c69a60eb-56f7-44c8-a636-11f93be08782",
        "status": "success"
      }
    ]
  }`;
  cancelOrderError = ` {
    "status": "failed",
    "items": [
      {
        "id": "08c6e05f-f165-4729-b504-af9535946f72",
        "status": "success"
      },
      {
        "id": "c69a60eb-56f7-44c8-a636-11f93be08782",
        "status": "fail",
        "message": "Item status is shipped, hence it cannot be canceled.
      }
    ]
  }`;

  trackingSampleResponse = `{
    "status": "shipped",
    "events": [
      {
        "time": "2019-04-20T01:02:03+00:00",
        "action": "created",
        "affected_items": [
          "08c6e05f-f165-4729-b504-af9535946f72",
          "c69a60eb-56f7-44c8-a636-11f93be08782"
        ]
      },
      {
        "time": "2019-04-20T01:02:03+00:00",
        "action": "printed",
        "affected_items": [
          "08c6e05f-f165-4729-b504-af9535946f72",
          "c69a60eb-56f7-44c8-a636-11f93be08782"
        ]
      },
      {
        "time": "2019-04-20T01:02:03+00:00",
        "action": "shipped",
        "affected_items": [
          "08c6e05f-f165-4729-b504-af9535946f72",
          "c69a60eb-56f7-44c8-a636-11f93be08782"
        ],
        "tracking_url": "https://test.com/track/1234554321",
        "tracking_number": "1234554321",
        "carrier": "USPS"
      },
      {
        "time": "2019-04-21T01:02:03+00:00",
        "action": "canceled",
        "affected_items": [
          "c69a60eb-56f7-44c8-a636-11f93be08782"
        ]
      }
    ]
  }`;

  invOptions = `{
    "in-stock": "When there is inventory available",
    "out-of-stock": "When there is no inventory available",
    "discontinued": "When there is no inventory, and it is not coming back"
  }`;
  pricingPrintObj = `{
    "price":"Price for these areas (integer)",
    "areas": ["Combination of areas for this price (array).]
  }`;

  getAllStockResponse = `{
    "00846907065236": { // SKU
      "status": "in-stock",
      "stock": 43
    },
    "00841016100557": { // SKU
      "status": "out-of-stock",
      "stock": 0
    },
    "10589252428287689": { // SKU
      "status": "in-stock",
      "stock": 66
    },
    "97667565345257": { // SKU
      "status": "discontinued",
      "stock": 12
    }
  }`;
  getSKUStockResponse = `{
    "status": "in-stock",
    "stock": 22
  }`;
  getAllPricingResponse = `{
    "00846907065236": { // SKU
      "blank": 550,
      "processing": 0,
      "printing": [
        {
          "areas": [
            "front"
          ],
          "price": 400
        },
        {
          "areas": [
            "back"
          ],
          "price": 400
        },
        {
          "areas": [
            "front",
            "back"
          ],
          "price": 700
        }
      ]
    },
    "00841016100557": { // SKU
      "blank": 750,
      "processing": 0,
      "printing": [
        {
          "areas": [
            "front"
          ],
          "price": 450
        },
        {
          "areas": [
            "back"
          ],
          "price": 400
        },
        {
          "areas": [
            "front",
            "back"
          ],
          "price": 725
        }
      ]
    },
    "10589252428287689": { // SKU
      "blank": 850,
      "processing": 1,
      "printing": [
        {
          "areas": [
            "front"
          ],
          "price": 300
        }
      ]
    }
  }`;
  getSKUPricingResponse = 
  `{
      "blank": 550,
      "processing": 0,
      "printing": [
        {
          "areas": [
            "front"
          ],
          "price": 400
        },
        {
          "areas": [
            "back"
          ],
          "price": 400
        },
        {
          "areas": [
            "front",
            "back"
          ],
          "price": 700
        }
      ]
    }`;

    
  printedWebhookCode = 
  `[
    {
      "event_id": "3c1329af-7612-4c1f-84c9-b85baae889c5",
      "occurred_at": "2022-05-01T12:00:00Z",
      "type": "shipped",
      "affected_item": "6299cd9f0b4ffeb32161132d"
      "tracking_url": "https://test.com/track/1234554321",
      "tracking_number": "1234554321",
      "carrier": "USPS"
    }
  ]`;

  constructor() { }

  ngOnInit() {
  }

}
